// extracted by mini-css-extract-plugin
export default {"root":"root___ZKLqO","isOpened":"isOpened___nC0Xc","closeBtn":"closeBtn___aBTJm"};